import React from 'react';
import { COUNTRY_DIAL_CODES } from '@/utils/countryDialCodes';

interface PhoneInputProps {
    countryCode: string;
    phone: string;
    onCountryCodeChange: (code: string) => void;
    onPhoneChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
}

export default function PhoneInput({
    countryCode,
    phone,
    onCountryCodeChange,
    onPhoneChange,
    placeholder = '620 00 00 00',
    disabled = false,
    error = false,
}: PhoneInputProps) {

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Ne conserver que les chiffres numériques
        const digits = e.target.value.replace(/\D/g, '');
        onPhoneChange(digits);
    };

    return (
        <div className={`flex items-center bg-slate-50/50 border rounded-xl overflow-hidden focus-within:bg-white focus-within:ring-2 focus-within:ring-teal-500/20 transition-all ${error
                ? 'border-rose-300 focus-within:border-rose-500 focus-within:ring-rose-500/20'
                : 'border-slate-200 focus-within:border-teal-500'
            }`}>
            {/* Sélecteur d'indicatif pays stylisé */}
            <div className="relative border-r border-slate-200 bg-slate-100/50 hover:bg-slate-100 transition-colors shrink-0">
                <select
                    value={countryCode}
                    disabled={disabled}
                    onChange={(e) => onCountryCodeChange(e.target.value)}
                    className="pl-3 pr-8 py-3 bg-transparent text-sm font-semibold text-slate-700 focus:outline-none appearance-none cursor-pointer disabled:cursor-not-allowed"
                >
                    {COUNTRY_DIAL_CODES.map((c) => (
                        <option key={c.code} value={c.code}>
                            {c.code}
                        </option>
                    ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-slate-400">
                    <i className="ri-arrow-down-s-line text-xs" />
                </div>
            </div>

            {/* Champ numérique principal */}
            <input
                type="tel"
                value={phone}
                disabled={disabled}
                onChange={handlePhoneChange}
                placeholder={placeholder}
                autoComplete="tel"
                className="w-full px-4 py-3 bg-transparent text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none disabled:cursor-not-allowed"
            />
        </div>
    );
}